import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TNotificationPersona,
  TNotificationPreferencesResponse,
} from './types';

export function useNotificationPreferences({
  persona,
}: { persona?: TNotificationPersona } = {}) {
  const requestURL = persona
    ? `notification-preferences?persona=${persona}`
    : 'notification-preferences';

  return useSWR<TNotificationPreferencesResponse>(
    requestURL,
    SWRFetcher({ method: 'GET' })
  );
}
